/**
 * Connector Correlation Service
 * Service for connector interface
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaybackMembershipAliasDto { 
    /**
     * Alias value (e.g. card number, external ID)
     */
    alias: string;
    /**
     * Type of the alias
     */
    aliasType?: string;
    /**
     * Identifier or program code
     */
    identifierCode?: string;
    /**
     * Role of this alias (main or additional)
     */
    role?: PaybackMembershipAliasDto.RoleEnum;
}
export namespace PaybackMembershipAliasDto {
    export type RoleEnum = 'main' | 'additional';
    export const RoleEnum = {
        Main: 'main' as RoleEnum,
        Additional: 'additional' as RoleEnum
    };
}


